import React from "react";
import PropTypes from "prop-types";
import { Field, } from "redux-form";
import { Row, Column } from "react-foundation";

import Popup from "./Popup";
import UpgradePopup from "./UpgradePopup";

import SwitchInput from "./SwitchInput";

import "css/extra-switch-field.css";

const propTypes = {
    upgradeExtra: PropTypes.object.isRequired,
    fieldName: PropTypes.string.isRequired,
    onChange: PropTypes.func
};

const ExtraSwitchField = ({ upgradeExtra, fieldName, onChange }) => (
    <Row className="extra-switch-field">
        <Column small={12}>
            <Field name={fieldName} component={SwitchInput} onChange={onChange}>
                { upgradeExtra.externalImageUrl1 &&
                    <img
                        src={ upgradeExtra.externalImageUrl1 }
                        alt=""
                        className="extra-switch-field__image"
                    />
                }
                <div className="extra-switch-field__description">
                    <h4>
                        {upgradeExtra.description1}
                        <Popup render={() => <UpgradePopup upgradeExtra={upgradeExtra} />}>
                            <span className="info-icon">i</span>
                        </Popup>
                    </h4>
                    <p>{upgradeExtra.description2}</p>
                </div>
            </Field>
        </Column>
    </Row>
);

ExtraSwitchField.propTypes = propTypes;

ExtraSwitchField.defaultProps = {
    onChange: () => {}
};

export default ExtraSwitchField;


// WEBPACK FOOTER //
// ./src/components/ExtraSwitchField.js